import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  WatchInternal,
} from 'react-hook-form';
import { OpenAIImageSizes } from '../../ImageGenerator/OpenAiImg';
import { openAiModelsImage } from '../../ImageGenerator/constants';

interface Props {
  errors: FieldErrors<any>;
  register: UseFormRegister<any>;
  systemType: string;
  setSystemType: React.Dispatch<React.SetStateAction<string>>;
  watch: WatchInternal<any>;
  control: Control<any>;
  setValue: UseFormSetValue<any>;
  systems: any[];
}

const ImageOpenAiConfigForm = ({
  errors,
  register,
  setSystemType,
  setValue,
  systemType,
  control,
  watch,
  systems,
}: Props) => {
  return (
    <Box
      mt={'16px'}
      sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}
    >
      <FormControl sx={{ width: '100%' }}>
        <InputLabel id="demo-simple-select-label">Ai System</InputLabel>
        <Select
          name="AiSystem"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label="Ai System"
          value={systemType}
          onChange={e => {
            setSystemType(e.target.value);
          }}
          sx={{
            width: '100%',
          }}
        >
          {systems.map((opt, index) => (
            <MenuItem
              key={index}
              value={opt.system}
              disabled={
                opt.models && opt.models.length > 0
                  ? opt.models.every((model: any) => model.disabledByCompany)
                  : false
              }
            >
              {opt.system === 'fal'
                ? 'Flux'
                : opt.system.charAt(0).toUpperCase() + opt.system.slice(1)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl
        sx={{
          width: '100%',
        }}
      >
        <InputLabel id="demo-simple-select-label">Model</InputLabel>
        <Select
          value={watch().openAiModels}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label="Ai System"
          {...register('openAiModels')}
          sx={{
            width: '100%',
          }}
        >
          {openAiModelsImage.map(opt => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl
        sx={{
          width: '100%',
        }}
      >
        <InputLabel id="demo-simple-select-label">Size</InputLabel>
        <Select
          value={watch().size}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label="Size"
          {...register('size')}
          sx={{
            width: '100%',
          }}
        >
          {OpenAIImageSizes.map(size => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ImageOpenAiConfigForm;
